import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, PlusCircle, Wrench } from "lucide-react";

export default function Employees() {
  return (
    <div className="space-y-4" data-testid="employees-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold text-navy">Master Karyawan</h1>
          <p className="text-sm text-muted-foreground">Data pegawai perusahaan</p>
        </div>
        <Button disabled data-testid="add-employee-btn" className="bg-primary/60 cursor-not-allowed" title="Segera Tersedia">
          <PlusCircle size={16} className="mr-1.5" /> Tambah Karyawan
          <span className="ml-2 text-[10px] bg-white/25 rounded px-1.5 py-0.5">Segera Tersedia</span>
        </Button>
      </div>
      <Card className="p-12 flex flex-col items-center justify-center text-center gap-3" data-testid="employees-empty">
        <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
          <Users size={26} className="text-slate-400" />
        </div>
        <h2 className="font-heading text-base font-semibold text-navy">Belum ada data karyawan</h2>
        <p className="text-sm text-muted-foreground max-w-md">
          Modul Master Karyawan untuk mengelola data pegawai (nama, jabatan, kontak) sedang disiapkan.
          Data ini terpisah dari <span className="font-medium text-navy">Users &amp; Roles</span> yang mengelola akun login.
        </p>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-1">
          <Wrench size={13} /> Segera Tersedia
        </div>
      </Card>
    </div>
  );
}
